import React from 'react';
import PropTypes from 'prop-types';

import { getPasswordRules, PASSWORD_HISTORY_SIZE } from '../../functions/passwordPolicy';

/**
 * Checklist de la politica de contraseñas (backend/users/validators.py). Se dibuja
 * debajo de los campos de contraseña para que el usuario vea que le falta mientras
 * escribe, en vez de enterarse recien al guardar.
 *
 * Con el campo vacio las reglas se muestran en gris (pendientes) y no en rojo: en los
 * ABM de edicion y en el perfil, dejar la contraseña vacia es valido y significa
 * "no cambiarla".
 */
const PasswordPolicyHint = ({ password }) => {
    const value = password || '';
    const vacio = value.length === 0;

    return (
        <ul className="list-unstyled small mb-0 mt-1">
            {getPasswordRules(value).map(rule => {
                let icon = 'fa fa-circle-o';
                let color = 'text-muted';

                if (rule.ok) {
                    icon = 'fa fa-check';
                    color = 'text-success';
                } else if (!vacio) {
                    icon = 'fa fa-times';
                    color = 'text-danger';
                }

                return (
                    <li key={rule.code} className={color}>
                        <i className={icon + ' mr-1'}></i>{rule.label}
                    </li>
                );
            })}
            {/* Va sin tilde porque no se puede verificar en el navegador: el historial
                son hashes que solo tiene el backend. Si la contraseña se repite, el
                error llega en la respuesta y se pinta debajo del campo. Se muestra
                igual para que el checklist no de a entender que estas son todas las
                reglas. */}
            <li className="text-muted">
                <i className="fa fa-info-circle mr-1"></i>
                No puede repetir ninguna de sus últimas {PASSWORD_HISTORY_SIZE} contraseñas
            </li>
        </ul>
    );
};

PasswordPolicyHint.propTypes = {
    password: PropTypes.string,
};

export default PasswordPolicyHint;



// WEBPACK FOOTER //
// ./src/components/PasswordPolicyHint/PasswordPolicyHint.js